var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 237 192"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.531 8.388v130.477a13 13 0 0 0 10.515 12.76l87.344 17.012v22.784L15.345 171.223A19 19 0 0 1 0 152.578V20.389c0-6.627 5.373-12 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.859 8.388v130.477a13 13 0 0 1-10.515 12.76L118 168.637v22.784l103.045-20.198a19 19 0 0 0 15.345-18.645V20.389c0-6.627-5.373-12-12-12zM111.21 151.878V11.912L47.328.182C41.352-.913 35.619 3.04 34.522 9.016a11 11 0 0 0-.18 1.987V136.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.341 151.878V11.912L189.224.182c5.975-1.096 11.708 2.858 12.805 8.833a11 11 0 0 1 .181 1.987V136.36z"
  }))));
};
export default SvgBook;